import IhmException from '@ch-types/CoralExceptionTypes/IhmException';

export default class ServiceException extends IhmException {}
